/* eslint-disable no-unused-vars */
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { QueryClientProvider } from 'react-query';
import { useSiteIdSynchronization } from '@hotjar/site';
import { HotsauceProvider, utils } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';
import { onNavigate } from '@hotjar/webapp/utils/routing/on-navigate';
import { BrowserRouter } from '@hotjar/webapp-routing';
import { log } from '@hotjar/insights-common/lib/log';
import * as SegmentTracking from '@hotjar/webapp/domains/common/tracking/segment';
import { configureAxiosDefaults } from '@hotjar/webapp/utils/axios-config';
import { queryClient } from '@hotjar/webapp/utils/react-query';
import { PlayerPage } from '@hotjar/webapp/features/Playbacks/PlayerPage';
import { StoreProvider } from '@hotjar/recordings/src/store/player/context';
import { createStore } from '@hotjar/recordings/src/store/player';
import { fetchSettings } from '@hotjar/recordings/src/features/Playbacks/utils';

configureAxiosDefaults();
SegmentTracking.setLogImplementation(log);
SegmentTracking.setLocationHrefGetter(() => location.href);

const root = document.getElementById('root');
const recordingStore = createStore();

function Providers({ children }) {
    const { i18n, ready } = useTranslation();

    return (
        <HotsauceProvider
            i18n={{
                strings: ready ? i18n.getResourceBundle(i18n.language, 'hotsauce') : {}
            }}
            onNavigate={onNavigate}
        >
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <StoreProvider store={recordingStore}>{children}</StoreProvider>
                </BrowserRouter>
            </QueryClientProvider>
        </HotsauceProvider>
    );
}

function GlobalRunTimeHooks() {
    useSiteIdSynchronization();

    return null;
}

// We need to ensure that window.settings is present when we render the app
fetchSettings(() => {
    ReactDOM.render(
        <Suspense fallback={<></>}>
            <Providers>
                <GlobalRunTimeHooks />
                <utils.GlobalStyle />
                <PlayerPage />
            </Providers>
        </Suspense>,
        root
    );
});
